var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "90px",
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.title,
      prop: "str"
    }
  }, [_c("editor", {
    staticClass: "my-editor",
    attrs: {
      "default-val": _vm.str,
      "is-document": false
    },
    on: {
      change: _vm.change
    }
  })], 1), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("确定")]), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };